import type { Ref } from 'react'
import { useEffect, useRef, useState } from 'react'

export const useSwiperRef = <T extends HTMLElement>(): [T | null, Ref<T>] => {
  const [container, setContainer] = useState<T | null>(null)
  const ref = useRef<T>(null)

  useEffect(() => {
    if (ref.current) {
      setContainer(ref.current)
    }
  }, [])

  return [container, ref]
}
